import React, { useCallback } from "react";
import { PickupLegIcon, DeliveryLegIcon } from "../../common/CustomIcon";
import { useLegSelection } from "./LegSelectionContext";
import { useLegSelected } from "./useLegStore";

const ICONS = {
  PICKUP: PickupLegIcon,
  DELIVERY: DeliveryLegIcon,
};

const LegCellInner = ({ orderId, locationType, locationId }) => {
  const { isLegWise, onLegToggle } = useLegSelection();
  const selectedLocationId = useLegSelected(orderId, locationType);

  const Icon = ICONS[locationType];
  if (!Icon || !locationId) return null;

  const isSelected = !!selectedLocationId;
  const isLocked = !isLegWise || isSelected;

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (!isLegWise) return;
      onLegToggle(orderId, locationType, locationId);
    },
    [isLegWise, onLegToggle, orderId, locationType, locationId]
  );

  return (
    <span
      className={`leg-badge-cell${isLocked ? " is-locked" : ""}`}
      onClick={handleClick}
    >
      <span className="leg-badge-base">
        <Icon state={isSelected ? "selected" : "selectable"} width={28} height={28} />
      </span>
      {!isLocked && (
        <span className="leg-badge-hover">
          <Icon state="hover" width={28} height={28} />
        </span>
      )}
    </span>
  );
};

const LegCell = React.memo(
  LegCellInner,
  (prev, next) =>
    prev.orderId === next.orderId &&
    prev.locationType === next.locationType &&
    prev.locationId === next.locationId
);

export default LegCell;
